<template>
  <div>
    <el-table :data="records">
      <!-- <el-table-column label="时间">
      <template slot-scope="scope">
        <span>{{scope.row.createTime | moment}}</span>
      </template>
    </el-table-column> -->
      <el-table-column prop="purchaseId" label="项目ID"> </el-table-column>
      <el-table-column prop="id" label="订单ID"> </el-table-column>
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="amount" label="数量"> </el-table-column>
      <el-table-column prop="coinType" label="币种"> </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 0">多的钱转回</span>
          <span v-else-if="scope.row.type == 1">转认购币</span>
          <span v-else-if="scope.row.type == 2">转推荐奖励</span>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">处理中</span>
          <span v-else-if="scope.row.status == 1">成功</span>
          <span v-else-if="scope.row.status == 2">失败</span>
          <span v-else-if="scope.row.status == 3">超时</span>
        </template>
      </el-table-column>
      <el-table-column prop="publicId" label="公共账号ID"> </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'purchaseRecordList',
  computed: {
    ...mapState('purchaseRecord', [
      'totalCount',
      'pagination',
      'rata',
      'records'
    ])
  },
  components: {
    Pagination
  },
  methods: {
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped></style>
